// Admin page ID mapping - maps menu item IDs to page enum values
// This converts the old format (admin/dashboard) to new format (admin_dashboard)

export const ADMIN_PAGE_ID_MAP: Record<string, string> = {
  'admin/dashboard': 'admin_dashboard',
  'admin/balance-check': 'admin_balance_check',
  'admin/useraccount': 'admin_useraccount',
  'admin/discounted-accounts': 'admin_discounted_accounts',
  'admin/pool-accounts': 'admin_pool_accounts',
  'admin/inactive-accounts': 'admin_inactive_accounts',
  'admin/terminated-accounts': 'admin_terminated_accounts',
  'admin/nexcore-vps-customers': 'admin_nexcore_vps_customers',
  'admin/nexcore-vps': 'admin_nexcore_vps',
  'admin/vps': 'admin_vps',
  'admin/terminals': 'admin_terminals',
  'admin/users': 'admin_users',
  'admin/user-roles': 'admin_user_roles',
  'admin/payments': 'admin_payments',
  'admin/payouts': 'admin_payouts',
  'admin/payment-discount': 'admin_payment_discount',
  'admin/paytiko-settings': 'admin_paytiko_settings',
  'admin/kyc': 'admin_kyc',
  'admin/support-tickets': 'admin_support_tickets',
  'admin/fin-support': 'admin_fin_support',
  'admin/subscribers': 'admin_subscribers',
  'admin/signatures': 'admin_signatures',
  'admin/contracts': 'admin_contracts',
  'admin/trades': 'admin_trades',
  'admin/performance': 'admin_performance',
  'admin/leaderboard': 'admin_leaderboard',
  'admin/certificates': 'admin_certificates',
  'admin/coupons': 'admin_coupons',
  'admin/promo-cards': 'admin_promo_cards',
  'admin/banner-config': 'admin_banner_config',
  'admin/account-banner-config': 'admin_account_banner_config',
  'admin/extended-banner-config': 'admin_extended_banner_config',
  'admin/popup-config': 'admin_popup_config',
  'admin/promo-code-landing-page': 'admin_promo_code_landing_page',
  'admin/dashboard-promo-card': 'admin_promo_code_landing_page',
  'admin/useractivities': 'admin_user_activities',
  'admin/trading-rules': 'admin_trading_rules',
  // Trademate group
  'admin/trademate-user-accounts': 'admin_trademate_user_accounts',
  'admin/trademate-accounts': 'admin_trademate_accounts',
  // Meta-API Accounts group. The two pages are gated separately: holding the
  // token page is a stronger grant than viewing account inventory.
  'meta-api-accounts': 'admin_meta_api_accounts',
  'admin/mtaccounts': 'admin_meta_api_accounts',
  'admin/metaapi-tokens': 'admin_meta_api_tokens',
};

// Reverse map: pageId -> path (for redirecting to first allowed admin page)
export const ADMIN_PAGE_ID_TO_PATH: Record<string, string> = Object.fromEntries(
  Object.entries(ADMIN_PAGE_ID_MAP)
    .filter(([key]) => key.startsWith('admin/')) // Only actual admin routes, not groups
    .map(([key, pageId]) => [pageId, `/${key}`])
);
